import React from "react";

const OurCampaignsSkeleton = () => {
    return (
        <div className="w-full py-4 mt-8 md:py-10 px-4 md:px-8 xl:px-[5rem]">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {[...Array(8)].map((_, index) => (
                    <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                        {/* Image placeholder */}
                        <div className="h-40 bg-gray-300 animate-pulse"></div>

                        <div className="p-4 space-y-4">
                            {/* Title placeholder */}
                            <div className="h-5 w-3/4 bg-gray-300 animate-pulse rounded"></div>

                            {/* Buttons row */}
                            <div className="flex justify-between">
                                <div className="h-8 w-20 bg-gray-300 animate-pulse rounded"></div>
                                <div className="flex gap-2">
                                    <div className="h-6 w-6 bg-gray-300 animate-pulse rounded-full"></div>
                                    <div className="h-6 w-6 bg-gray-300 animate-pulse rounded-full"></div>
                                </div>
                            </div>

                            {/* Progress bar */}
                            <div className="w-full h-2 bg-gray-300 animate-pulse rounded"></div>

                            {/* Raised/Goal */}
                            <div className="flex justify-between">
                                <div className="h-3 w-16 bg-gray-300 animate-pulse rounded"></div>
                                <div className="h-3 w-16 bg-gray-300 animate-pulse rounded"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OurCampaignsSkeleton;